import { z } from 'zod'

export const paramsSchema = z.object({
  id: z.string(),
})

export type paramsType = z.infer<typeof paramsSchema>
